/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       HostFactory.ts
 * @author     Christian Ascone
 * @date       12/27/19 10:01 AM
 */


import faker from 'faker';
import {Host, HostType} from "@services/src/models";

export class HostFactory {
    static factoryArray(size: number): Host[] {
        let array = [];
        for (let i = 0; i < size; i++) {
            array.push(HostFactory.factory());
        }
        return array;
    }

    static factory(): Host {
        return {
            id: faker.random.number(4),
            firstName: faker.name.firstName(),
            lastName: faker.name.lastName(),
            email: faker.internet.email(),
            mobile: faker.phone.phoneNumber(),
            fiscalCode: faker.random.alphaNumeric(16),
            type: HostType.Private,
            usageThreshold: 0,
        };
    }
}

